import { Mapper } from "../../../../base/utils/mapper";
import { TypeBloodModel } from "../../../../domain/models/configuration/type-blood";
import { TypeBloodEntity } from "../entities/type-blood.entity";


export class TypeBloodImplementationRepositoryMapper extends Mapper<TypeBloodEntity, TypeBloodModel> {
    mapFrom(param: TypeBloodEntity): TypeBloodModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeBloodModel): TypeBloodEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}